import React, { useEffect, useState } from 'react';
import WeatherCard from './WeatherCard';
import './style.css';
function Weather(props) {
    const [search, setSearch] = useState('mumbai');
    const [tempInfo, setTempInfo] = useState('');
    console.log(tempInfo, 'TTTTTTTTEEEEMPPPIIIII');
    const getWeatherData = async () => {
        try {
            let url = `https://api.openweathermap.org/data/2.5/weather?q=${search}&units=metric&APPID=76b13339712cc24c865f805a9ca9d8bb`;
            let res = await fetch(url);
            let data = await res.json();
            console.log(data, 'datadatadatadata');
            const { temp, humidity, pressure } = data.main;
            console.log(temp);
            const { main: weatherMood } = data.weather[0];
            const { name } = data;
            const { speed } = data.wind;
            const { country, sunset } = data.sys;
            const newWeatherInfo = { temp, humidity, pressure, name, weatherMood, speed, country, sunset };
            setTempInfo(newWeatherInfo);
        } catch (errors) {
            console.log(errors);
        }
    };
    useEffect(() => {
        getWeatherData();
    }, []);
    return (
        <>
            {/* <div className="wrap"> */}
            <div className="search">
                <input
                    type="search"
                    id="search"
                    autoFocus
                    placeholder="Search Your Locality..."
                    className="search-input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <button className="searchButton" type="button" onClick={getWeatherData}>
                    Search
                </button>
            </div>
            {/* </div> */}

            {/* card Design */}
            <WeatherCard {...tempInfo} />
        </>
    );
}

export default Weather;
